<template lang="html">
  <div class="col px-0 d-flex content-detail" style="height: 80%">
    <greeting-list
      :greetings="greetings"
      class="col-5 d-flex flex-column"
      style="height: 100%"
      @search="handleSearch"
    />
    <greeting-detail
      :homes="homes"
      :greetings="greetings"
      class="col-7 d-flex flex-column"
      style="height: 100%"
    />
  </div>
</template>
<script>
import axios from "axios"
import { getCookie, Auth } from "@/lib/cookie"
import GreetingList from "./GreetingList"
import GreetingDetail from "./GreetingDetail"

export default {
  name: "GreetingView",
  components: {
    GreetingList,
    GreetingDetail,
  },
  data() {
    return {
      interval: null,
      homes: null,
      greetings: null,
    }
  },
  watch: {
    $route(to) {
      if (to.params.userId) {
        this.loadHomes(to.params.userId)
      } else {
        this.homes = null
      }
      this.loadGreetings().then()
    },
  },
  created() {
    this.loadAll().then()
    this.interval = setInterval(
      () => {
        this.loadGreetings().then()
      },
      10 * 60 * 1000,
    ) // 10 min interval
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    async handleSearch(keyword) {
      if (this.$route !== "Greeting") {
        this.$router.replace({ name: "Greeting" })
      }
      await this.loadAll(keyword.searchName, keyword.searchHome)
    },
    async loadAll(name = "", home = "") {
      this.greetings = await this.loadGreetings(name, home)
      if (this.$route.params.userId) {
        await this.loadHomes(this.$route.params.userId)
      }
    },
    loadHomes(userId) {
      this.homes = null
      return axios
        .get(`${process.env.HOST}/admin/greeting/${userId}/homes`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((result) => {
          this.homes = result.data || []
          return this.homes
        })
        .catch((error) => {
          this.homes = null
          throw error
        })
    },
    loadGreetings(name = "", home = "") {
      return axios
        .get(
          `${process.env.HOST}/admin/greeting/members?name=${name}&home=${home}`,
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
            },
          },
        )
        .then((res) => {
          const greetings = res.data || []
          greetings.forEach((greeting, greetingIndex) => {
            if (greeting.imageKey) {
              const { imageKey } = greeting
              axios
                .get(`${process.env.HOST}/api/downloads/image`, {
                  params: {
                    imageKey,
                  },
                })
                .then((resImage) => {
                  greetings[greetingIndex] = {
                    ...greetings[greetingIndex],
                    imageUrl: resImage
                  };
                })
                .catch(() => {
                  // swallow image download failures so the rest of the greetings still load
                });
            }
          })
          return greetings
        })
        .catch((e) => {
          this.$message.error("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง")
          throw e
        })
    },
  },
}
</script>
